import React from "react";
import { Route, withRouter } from "react-router-dom";

class InformationButton extends React.Component {
  btn = props => {
    return (
      <Route
        render={({ history }) => (
          <button
            className="link-button"
            type="button"
            onClick={() => {
              history.push(props.to + props.id);
            }}
          >
            <i aria-hidden="true" className="material-icons icon-link-button">
              error_outline
            </i>
            <div className="font-size-smaller text-link-button">
              {props.text("common.contact_information")}
            </div>
          </button>
        )}
      />
    );
  };

  render() {
    return this.btn(this.props);
  }
}

export default withRouter(InformationButton);






// WEBPACK FOOTER //
// ./src/components/buttons/InformationButton.js